module.exports = __webpack_public_path__ + "img/grading_item_bg.83c5cd5d.png";